// extracted by mini-css-extract-plugin
export default {"container":"QjOFy7uHFH0c5cAQBVVq","prompt":"P7MeWR4Y9bPXs6sfryGD"};